import { APP_ID, ApplicationConfig, ErrorHandler, importProvidersFrom, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, Routes, withInMemoryScrolling, withViewTransitions } from '@angular/router';
import { BrowserModule, provideClientHydration, withEventReplay, withIncrementalHydration } from '@angular/platform-browser';
import { DecimalPipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { GlobalErrorHandler } from './core/helpers/global-error-handler';
import { provideInitializer } from './core/initializer/initializer-queue';
import { CacheControlInterceptor } from './core/interceptors/cache-control.interceptor';
import { provideStoreInitializer } from 'ngx-unificator/store';
import { GlobalStore } from './core/store';
import { HostRequestsInterceptor } from './core/interceptors/host-requests.interceptor';
import { provideBrandConfig } from './core/services/brand-config/brand-config.provider';
import { apolloProvider } from './core/services/graphql/graphql.provider';
import { provideBotRules } from './core/providers/bot-rules.provider';
import { provideMobConsole } from './core/providers/mob-console.provider';
import { onViewTransitionCreated } from './core/services/view-transition.service';
import { abTestList } from './core/ab-test/ab-test.data';
import { provideABTest } from './core/ab-test/ab-test.provider';
import { provideToast } from './core/shared/components/toast/provide-toast';
import { ToastService } from './core/shared/components/toast/toast.service';
import { ToastHostComponent } from './core/shared/components/toast/toast.component';
import { CustomTransferCacheInterceptor } from './core/interceptors/custom-transfer-cache.interceptor';
import { TranslationService } from './core/services/translation/translation.service';
import { DisplayCurrencyPipe } from './core/shared/pipes/display-currency.pipe';

const routes: Routes = [
  {
    path: '',
    children: [{ path: '', loadChildren: () => import('./page/page.module').then(m => m.PageModule) }],
  },
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideStoreInitializer(GlobalStore),
    provideABTest(abTestList),
    provideInitializer(),
    provideBrandConfig(),
    provideBotRules(),
    provideMobConsole(),
    apolloProvider(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideClientHydration(
      withIncrementalHydration(),
      withEventReplay()
    ),
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
      withViewTransitions({ onViewTransitionCreated }),
    ),
    provideNgxMask(),
    provideToast({service: ToastService, hostComponent: ToastHostComponent, translateService: TranslationService}),
    importProvidersFrom(
      BrowserModule,
      FormsModule,
      ReactiveFormsModule,
      NgxMaskDirective,
    ),
    DecimalPipe,
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheControlInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HostRequestsInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomTransferCacheInterceptor,
      multi: true,
    },
    { provide: APP_ID,  useValue: 'winthrone' },
    DisplayCurrencyPipe
  ],
};
